import { render, staticRenderFns } from "./NovoConsignado.vue?vue&type=template&id=d8f52ac2&"
import script from "./NovoConsignado.vue?vue&type=script&lang=js&"
export * from "./NovoConsignado.vue?vue&type=script&lang=js&"
import style0 from "./NovoConsignado.vue?vue&type=style&index=0&id=d8f52ac2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports